import { CcParamsGen } from "./../cc-params-gen/cc-params-gen"
import {
	Component,
	Input,
	OnInit,
	ViewChild,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { CreateTakbullAccountComponent } from "@app/create-takbull-account/create-takbull-account.component"
import { CreateGrowAccountComponent } from "@app/create-grow-account/create-grow-account.component"

@Component({
	selector: "app-cc-params-credit-clearance",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		ModalWrapComponent,
		CreateTakbullAccountComponent,
		CreateGrowAccountComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div>
			<button
				titleLang="create_takbull_account"
				tabindex="-1"
				class="btn btn-primary"
				(click)="modalOpen = 'create-takbull-account'"
			>
				{{ "create_takbull_account" | langVal }}
			</button>
		</div>
		<div>
			<button
				titleLang="create_grow_account"
				tabindex="-1"
				class="btn btn-primary"
				(click)="modalOpen = 'create-grow-account'"
			>
				{{ "create_grow_account" | langVal }}
			</button>
		</div>
		@switch (modalOpen) {
			@case ("create-takbull-account") {
				<app-modal-wrap
					(onClose)="modalOpen = null"
					modalWrapperClass="modal-small-width"
					title="create_takbull_account"
				>
					<app-create-takbull-account (onClose)="modalOpen = null" />
				</app-modal-wrap>
			}
			@case ("create-grow-account") {
				<app-modal-wrap
					(onClose)="modalOpen = null"
					modalWrapperClass="modal-small-width"
					title="create_grow_account"
				>
					<app-create-grow-account (onClose)="modalOpen = null" />
				</app-modal-wrap>
			}
		}
	`,
})
export class CcParamsCreditClearanceComponent extends CcParamsGen {
	modalOpen: string | null = null
}
